import { PageHeader } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { RevxButton } from 'components/RevxButton';
import { buildCreateOrgSkuMarkupParam } from 'domains/markupDomain';
import { useOrg } from 'hooks/useOrg';
import React from 'react';
import { useTranslation } from 'react-i18next';
import SkuMarkupItemForm from './SkuMarkupItemForm';
import SkuMarkupTable from './SkuMarkupTable';

const OrgSkuMarkupTab = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const curItem = useAppSelector((state) => state.markup.curSkuMarkup);
  const org = useOrg();

  return (
    <>
      <PageHeader
        ghost={false}
        extra={[
          <RevxButton
            key="create"
            type="primary"
            onClick={() => {
              dispatch.markup.saveMarkup(buildCreateOrgSkuMarkupParam(org!.id));
            }}
          >
            {t('platform.markup.titles.create')}
          </RevxButton>,
        ]}
      />

      {curItem && <SkuMarkupItemForm />}
      <SkuMarkupTable />
    </>
  );
};

export default OrgSkuMarkupTab;
